import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import {
	restoreDeletedPage,
	updatePageReorderConflictWithIncoming
} from '@editor2/services/conflictResolutionService';
import { getParentEntityByPageId } from '@editor2/components/CourseChangesDiff/helpers';

export class PageDeletedModifiedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		state.initialCourse.pages.entities[entityId] = incoming as any;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		restoreDeletedPage(state, entityId);

		state.pages.entities[entityId] = incoming as any;

		const initialParent =
			getParentEntityByPageId(state.initialCourse.chapters, entityId) ||
			getParentEntityByPageId(state.initialCourse.page_groups, entityId);
		updatePageReorderConflictWithIncoming(state, initialParent);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
